import { z } from 'zod'

// E10 F10-2 — the lean "invite a user into the workspace" form. Captures the invitee's name + email and an
// expiry window (1 / 3 / 7 days, matching the backend validator). Group/role assignment is done afterwards
// via the existing user edit flow, so it is intentionally not on the invite form.
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const inviteUserSchema = z.object({
  firstName: z.string().min(1, 'First name is required').max(150, 'First name must be maximum 150 characters'),
  lastName: z.string().min(1, 'Last name is required').max(150, 'Last name must be maximum 150 characters'),
  email: z
    .string()
    .min(1, 'Email is required')
    .max(250, 'Email must be maximum 250 characters')
    .refine((email) => emailRegex.test(email), 'Enter a valid email address'),
  expiryDays: z
    .number()
    .refine((d) => d === 1 || d === 3 || d === 7, 'Invitation expiry must be 1, 3, or 7 days'),
})

export type InviteUserFormData = z.infer<typeof inviteUserSchema>
